import React from 'react';
import { Mail, MapPin, Linkedin, Video } from 'lucide-react';

interface ContactInfoProps {
  onBookingClick: () => void;
}

const ContactInfo: React.FC<ContactInfoProps> = ({ onBookingClick }) => {
  return (
    <div>
      <h2 className="text-3xl font-bold mb-6">
        Parlons de votre projet !
      </h2>
      <div className="space-y-4">
        <div className="flex items-center">
          <Mail className="w-6 h-6 text-blue-600 mr-3" />
          <span>certifrance@consultant.com</span>
        </div>
        <div className="flex items-center">
          <MapPin className="w-6 h-6 text-blue-600 mr-3" />
          <span>Basé à Grenoble, interventions possibles partout en France</span>
        </div>
        <div className="flex items-center">
          <Linkedin className="w-6 h-6 text-blue-600 mr-3" />
          <a 
            href="https://www.linkedin.com/in/guillaume-bray-gte/details/experience/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:text-blue-700"
          >
            LinkedIn
          </a>
        </div>
        <button
          onClick={onBookingClick}
          className="flex items-center bg-green-500 text-white px-6 py-3 rounded-full hover:bg-green-600 transition-colors mt-6"
        >
          <Video className="w-5 h-5 mr-2" />
          Réserver une visio
        </button>
      </div>
    </div>
  );
};

export default ContactInfo;